import { useCallback } from 'react'
import { useSlsHighlightsContext, useSlsStateContext } from '@fs/zion-sls'
import { useR2Highlights, useR2StateContext } from '../../../providers/r2Provider/R2Context'
import { onRectangleDrawnSlsHook } from '../../../utils/imageHighlightUtils'

export default function useRectangleDrawnHandler() {
  const { currentImageArk, images: imagesData } = useSlsStateContext()
  const r2State = useR2StateContext()
  const { activeFieldInfo, setCreatingRects, getHighlights } = useSlsHighlightsContext()
  const { displayHighlightsApi } = useR2Highlights()

  const rectangleDrawnHandler = useCallback(
    (position) => {
      onRectangleDrawnSlsHook(
        position,
        imagesData,
        currentImageArk,
        r2State,
        getHighlights,
        displayHighlightsApi,
        activeFieldInfo
      )
      setCreatingRects(false)
    },
    [activeFieldInfo, currentImageArk, displayHighlightsApi, getHighlights, imagesData, r2State, setCreatingRects]
  )

  return rectangleDrawnHandler
}
